module.exports = __webpack_public_path__ + "static/SB-610bd9afd80150f09102b3f859b48a8c.jpg";